<ng-container *transloco="let t">
  <div class="mb-4">
    <app-admin-card-with-title [cardTitle]="t('account.statements.list.of.statement.items')" [removeTopMargin]="true">
      <div>
        @if ((currentAccountStatementItemList.length ?? 0) > 0) {
          <!-- Desktop -->
          <div>
            <div class="table-responsive d-xl-block d-none">
              <app-sortable-table [infiniteScrollDistance]="4" cssClass="table table-last-row-no-border" infinite-scroll
                                  [items]="currentAccountStatementItemList">
                <thead>
                <tr>
                  <th scope="col" [sortBy]="['id']" class="id-column-width">{{ t("account.statements.id") }}</th>
                  <th scope="col" [sortBy]="['payerName']">{{
                      t("account.statements.payer.iban")
                    }}
                  </th>
                  <th scope="col" [sortBy]="['referenceId']">{{ t("account.statements.payer.desc.reference") }}
                  </th>
                  <th scope="col" [sortBy]="['amount.amount']"
                      class="amount-column-width">{{ t("account.statements.amount.currency") }}
                  </th>
                  <th scope="col" [sortBy]="['registrationId']"
                      class="registration-column-width">{{ t("account.statements.amount.registrationId") }}
                  </th>
                  <th scope="col"
                      class="">{{ t("account.statements.amount.event.race") }}
                  </th>
                  <th scope="col"
                      class="status-column-width">{{ t("account.statements.item.status") }}
                  </th>
                  @if (accountStatement?.status === ImportStatus.OPEN) {
                    <th class="more-column-width"></th>
                  }
                </tr>
                </thead>
                <tbody>
                  @for (accountStatementItem of currentAccountStatementItemList;track accountStatementItem) {
                    <tr>
                      <td class="center-align">{{ accountStatementItem.id }}</td>
                      <td class="center-align">
                        <div>{{
                            accountStatementItem.payerName + ", " + (accountStatementItem.payerAddresLine1 ?? "") +
                            " " +
                            (accountStatementItem.payerAddresLine2 ?? "") + "" + (accountStatementItem.payerAddresLine3
                              ??
                              "")
                          }}
                        </div>
                        <div>{{
                            accountStatementItem.payerIban
                          }}
                        </div>
                      </td>
                      <td class="center-align">
                        <div>{{ accountStatementItem.paymentDesc ?? "" }}</div>
                        <div>{{
                            accountStatementItem.referenceId
                          }}
                        </div>
                      </td>
                      <td class="center-align">
                        <div class="status-badge"
                             [ngClass]="{'accepted': accountStatementItem.amountStatus === 0 , 'blue':
                           accountStatementItem.amountStatus === 1, 'denied': accountStatementItem.amountStatus === 2}">
                  <span class="fw-bold">
                    {{
                      accountStatementItem.amount?.amount |
                        myCurrency:accountStatementItem.amount?.currency
                    }}
                  </span>
                        </div>
                      </td>
                      <td class="center-align">{{ accountStatementItem.registrationId }}</td>
                      <td class="center-align">
                        @if (accountStatementItem.event && accountStatementItem.event.racesList &&
                        accountStatementItem.event.racesList.length === 1) {
                          <div>
                            <app-language-output [hrLabel]="accountStatementItem.event!.name"
                                                 [enLabel]="accountStatementItem.event!.nameEng"
                                                 [itLabel]="accountStatementItem.event!.nameIta"
                                                 [siLabel]="accountStatementItem.event!.nameSlo"
                                                 [srLabel]="accountStatementItem.event!.nameSr"
                                                 [bsLabel]="accountStatementItem.event!.nameBs"
                                                 [defaultLanguage]="accountStatementItem.event!.defaultLanguage"
                                                 [languages]="languages"/>
                          </div>
                          <div>
                            <app-language-output [hrLabel]="accountStatementItem.event!.racesList![0].name"
                                                 [enLabel]="accountStatementItem.event!.racesList![0].nameEng"
                                                 [itLabel]="accountStatementItem.event!.racesList![0].nameIta"
                                                 [siLabel]="accountStatementItem.event!.racesList![0].nameSlo"
                                                 [srLabel]="accountStatementItem.event!.racesList![0].nameSr"
                                                 [bsLabel]="accountStatementItem.event!.racesList![0].nameBs"
                                                 [defaultLanguage]="accountStatementItem.event!.defaultLanguage"
                                                 [languages]="languages"/>
                          </div>
                        }
                      </td>
                      <td class="center-align">
                        <div class="status-badge"
                             [ngClass]="{'on-hold': accountStatementItem.importMatchType === 0 , 'accepted': accountStatementItem.importMatchType === 1,
                           'publishing': accountStatementItem.importMatchType === 2}">
                  <span class="fw-bold">
                    {{ t("account.statements.item.status." + accountStatementItem.importMatchType) | uppercase }}
                  </span>
                        </div>
                      </td>

                      @if (accountStatement?.status === ImportStatus.OPEN) {
                        <td class="text-end center-align">
                          <div (click)="deleteStatementItem(accountStatementItem)">
                    <span class="delete-icon">
                      <i class="fas fa-trash-alt"></i>
                    </span>
                          </div>
                        </td>
                      }

                    </tr>
                  }
                </tbody>
              </app-sortable-table>
            </div>
            <!-- Mobile -->
            @for (accountStatementItem of currentAccountStatementItemList;let isLast = $last;track accountStatementItem) {
              <div class="d-block d-xl-none">
                <div [class.isLastRow]="isLast"
                     class="d-flex justify-content-center align-items-center mobile-table-row">
                  <div class="flex-grow-1">
                    <div [class.isLastRow]="isLast" class="d-flex flex-column">
                      <div>
                        <strong>{{ t("account.statements.id") }}:</strong>{{ accountStatementItem.id }}
                      </div>
                      <div>
                        <strong>{{ t("account.statements.payer.iban") }}:</strong>{{
                          (accountStatementItem.payerName ?? '-') + "/" + (accountStatementItem.payerIban ?? '-')
                        }}
                      </div>
                      <div>
                        <strong>{{ t("account.statements.payer.address") }}:</strong>{{
                          (accountStatementItem.payerAddresLine1 ?? "") + " " +
                          (accountStatementItem.payerAddresLine2 ?? "") + "" + (accountStatementItem.payerAddresLine3 ??
                            "")
                        }}
                      </div>

                      <div>
                        <strong>{{ t("account.statements.payer.desc.reference") }}:</strong>{{
                          (accountStatementItem.paymentDesc ?? '-') + "/" + (accountStatementItem.referenceId ?? '-')
                        }}
                      </div>
                      <div>
                        <strong>{{ t("account.statements.amount.currency") }}:</strong>{{
                          accountStatementItem.amount?.amount |
                            myCurrency:accountStatementItem.amount?.currency
                        }}
                      </div>
                      <div>
                        <strong>{{ t("account.statements.amount.registrationId") }}
                          :</strong>{{ accountStatementItem.registrationId }}
                      </div>
                      <div>
                        <strong>{{ t("account.statements.amount.event.race") }}:</strong>
                        <div>
                          <app-language-output [hrLabel]="accountStatementItem.event!.name"
                                               [enLabel]="accountStatementItem.event!.nameEng"
                                               [itLabel]="accountStatementItem.event!.nameIta"
                                               [siLabel]="accountStatementItem.event!.nameSlo"
                                               [srLabel]="accountStatementItem.event!.nameSr"
                                               [bsLabel]="accountStatementItem.event!.nameBs"
                                               [defaultLanguage]="accountStatementItem.event!.defaultLanguage"
                                               [languages]="languages"/>
                        </div>
                        <div>
                          <app-language-output [hrLabel]="accountStatementItem.event!.racesList![0].name"
                                               [enLabel]="accountStatementItem.event!.racesList![0].nameEng"
                                               [itLabel]="accountStatementItem.event!.racesList![0].nameIta"
                                               [siLabel]="accountStatementItem.event!.racesList![0].nameSlo"
                                               [srLabel]="accountStatementItem.event!.racesList![0].nameSr"
                                               [bsLabel]="accountStatementItem.event!.racesList![0].nameBs"
                                               [defaultLanguage]="accountStatementItem.event?.defaultLanguage"
                                               [languages]="languages"/>
                        </div>
                      </div>
                      <div>
                        <strong>{{ t("account.statements.item.status") }}:</strong> {{
                          t("account.statements.item.status." + accountStatementItem.importMatchType)
                        }}
                      </div>
                    </div>
                  </div>
                  @if (accountStatement?.status === ImportStatus.OPEN) {
                    <div (click)="deleteStatementItem(accountStatementItem)">
              <span class="delete-icon">
                <i class="fas fa-trash-alt"></i>
              </span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="pt-2 pb-4">
            <app-empty-state/>
          </div>
        }
      </div>
    </app-admin-card-with-title>
  </div>
  <app-admin-card-with-title [cardTitle]="t('account.statements.registrations.list')" [removeTopMargin]="true">
    <div slot="trailingWidget">
      <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                          (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
    </div>
    <app-loader [isLoading]="isLoading"></app-loader>
    <div>
      @if ((raceRegistrations.length ?? 0) > 0) {
        <!-- Desktop -->
        <div>
          <div class="table-responsive d-xl-block d-none">
            <app-sortable-table [infiniteScrollDistance]="4" cssClass="table table-last-row-no-border" infinite-scroll
                                [items]="raceRegistrations">
              <thead>
              <tr>
                <th scope="col" [sortBy]="['id']" class="id-column-width--registration">{{
                    t("account.statements.amount.registrationId")
                  }}
                </th>
                <th scope="col">{{ t("account.statements.payer.code") }}</th>
                <th scope="col">{{ t("account.statements.payer.desc.reference") }}</th>
                <th scope="col">{{ t("account.statements.amount.event.race") }}</th>
                <th class="more-column-width"></th>
              </tr>
              </thead>
              <tbody>
                @for (raceRegistration of raceRegistrations;track raceRegistration) {
                  <tr>
                    <td class="center-align">{{ raceRegistration.id }}</td>
                    <td class="center-align">{{
                        raceRegistration.order?.payeeCode ?? "-"
                      }}
                    </td>
                    <td class="center-align">{{
                        raceRegistration.order?.paymentDesc ?? "-"
                      }}
                    </td>
                    <td class="center-align">
                      @if (raceRegistration.events && raceRegistration.race) {
                        <div>
                          <app-language-output [hrLabel]="raceRegistration.events.name"
                                               [enLabel]="raceRegistration.events.nameEng"
                                               [itLabel]="raceRegistration.events.nameIta"
                                               [siLabel]="raceRegistration.events.nameSlo"
                                               [srLabel]="raceRegistration.events.nameSr"
                                               [bsLabel]="raceRegistration.events.nameBs"
                                               [defaultLanguage]="raceRegistration.events.defaultLanguage"
                                               [languages]="languages"/>
                        </div>
                        <div>
                          <app-language-output [hrLabel]="raceRegistration.race.name"
                                               [enLabel]="raceRegistration.race.nameEng"
                                               [itLabel]="raceRegistration.race.nameIta"
                                               [siLabel]="raceRegistration.race.nameSlo"
                                               [srLabel]="raceRegistration.race.nameSr"
                                               [bsLabel]="raceRegistration.race.nameBs"
                                               [defaultLanguage]="raceRegistration.events.defaultLanguage"
                                               [languages]="languages"/>
                        </div>
                      }
                    </td>
                    <td class="text-end center-align">
                      <div (click)="registrationDetails(raceRegistration)">
                    <span class="delete-icon">
                      <i class="fas fa-eye"></i>
                    </span>
                      </div>
                    </td>

                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div>
          <!-- Mobile -->
          @for (raceRegistration of raceRegistrations;let isLast = $last;track raceRegistration) {
            <div class="d-block d-xl-none">
              <div [class.isLastRow]="isLast" class="d-flex justify-content-center align-items-center mobile-table-row">
                <div class="flex-grow-1">
                  <div [class.isLastRow]="isLast" class="d-flex flex-column">
                    <div>
                      <strong>{{ t("account.statements.amount.registrationId") }}:</strong>{{ raceRegistration.id }}
                    </div>
                    <div>
                      <strong>{{ t("account.statements.payer.code") }}:</strong>{{
                        (raceRegistration.order?.payeeCode ?? '-')
                      }}
                    </div>
                    <div>
                      <strong>{{ t("account.statements.payer.desc.reference") }}:</strong>{{
                        (raceRegistration.order?.paymentDesc ?? '-')
                      }}
                    </div>
                    <div>
                      <strong>{{ t("account.statements.amount.event.race") }}:</strong>
                      @if (raceRegistration.events && raceRegistration.race) {
                        <div>
                          <app-language-output [hrLabel]="raceRegistration.events.name"
                                               [enLabel]="raceRegistration.events.nameEng"
                                               [itLabel]="raceRegistration.events.nameIta"
                                               [siLabel]="raceRegistration.events.nameSlo"
                                               [srLabel]="raceRegistration.events.nameSr"
                                               [bsLabel]="raceRegistration.events.nameBs"
                                               [defaultLanguage]="raceRegistration.events.defaultLanguage"
                                               [languages]="languages"/>
                        </div>
                        <div>
                          <app-language-output [hrLabel]="raceRegistration.race.name"
                                               [enLabel]="raceRegistration.race.nameEng"
                                               [itLabel]="raceRegistration.race.nameIta"
                                               [siLabel]="raceRegistration.race.nameSlo"
                                               [srLabel]="raceRegistration.race.nameSr"
                                               [bsLabel]="raceRegistration.race.nameBs"
                                               [defaultLanguage]="raceRegistration.events.defaultLanguage"
                                               [languages]="languages"/>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div (click)="registrationDetails(raceRegistration)">
              <span class="delete-icon">
                <i class="fas fa-eye"></i>
              </span>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="pt-2 pb-4">
          <app-empty-state/>
        </div>
      }
    </div>
  </app-admin-card-with-title>
  <app-action-buttons-row [saveLabelTranslationKey]="'account.statements.confirm.import'" (onSave)="confirmImport()"
                          [saveVisible]="accountStatement?.status === ImportStatus.OPEN"/>
</ng-container>

